import { createReducer } from 'deox';
import { Organisation } from '@/types';
import { fetchOrganizationInvitationActions } from '../actions';

export interface InvitationState {
  organisationToJoin?: Organisation;
}

const initialState: InvitationState = {
  organisationToJoin: undefined,
};

const invitationReducer = createReducer(initialState, (handleAction) => [
  handleAction(fetchOrganizationInvitationActions.success, (state, { payload }) => ({
    ...state,
    organisationToJoin: payload.organisation,
  })),
]);

export default invitationReducer;
